import { defineStore } from 'pinia';
import BuyerMessage from '../types/interfaces/global/BuyerMessage';
import serverFetch from '../globals/ServerFetch';

// eslint-disable-next-line import/prefer-default-export
export const useBuyerMessagesStore = defineStore({
	id: 'buyerMessages',
	state: () => ({
		/**
		 * Lista wiadomości.
		 */
		buyerMessagesList: [] as BuyerMessage[],
		/**
		 * Liczba nieprzeczytanych wiadomości.
		 */
		buyerMessagesCount: 0,
		/**
		 * Czy dzwonek jest aktywny.
		 */
		isBellRinging: false,
	}),
	actions: {
		/**
		 * Pobiera listę wiadomości z serwera.
		 */
		async update() {
			const result = [] as Array<BuyerMessage>;
			const messages = (await serverFetch('/buyer/notification/find-all.do', {}, 'GET', false, false)).all_notification_json || [];
			let readCount = 0;

			for (const msg of (messages || [])) {
				let msgType;
				switch (msg.id_notif_type) {
				case 1:
					msgType = 'uncoverRfp';
					break;
				case 2:
					msgType = 'message';
					break;
				default:
					msgType = 'other';
					break;
				}
				result.push({
					id: msg.id,
					type: msgType as BuyerMessage['type'],
					title: msg.title,
					message: msg.description,
					date: new Date(msg.ts_created),
					isRead: msg.is_read,
					action: msg.redirect_url,
				});

				if (msg.read) { readCount++; }
			}

			this.buyerMessagesCount = result.length - readCount;
			this.buyerMessagesList = result;
			this.isBellRinging = false;
		},

		/**
		 * Oznacza wszystkie wiadomości jako przeczytane.
		 */
		async readAll() {
			this.buyerMessagesCount = 0;
		},

		/**
		 * Oznacza wiadomość jako przeczytaną.
		 */
		async markAsRead(message:BuyerMessage) {
			const { id } = message;
			const foundMessage = this.buyerMessagesList.find((m) => m.id === id);
			if (foundMessage && !foundMessage.isRead) {
				foundMessage.isRead = true;
				this.buyerMessagesCount--;

				await fetch(`/buyer/notification/set-is-read-true/${id}.do`, {
					method: 'PUT',
				});
			}
		},
		async checkIfBellIsRinging() {
			await fetch('/buyer/notification/is-bell-ringing.do').then((response) => {
				if (response.ok) {
					response.json().then((data) => {
						this.isBellRinging = data;
					});
				}
			});
		},
		async unringTheBell() {
			await fetch('/buyer/notification/set-is-ringing-bell-false.do', {
				method: 'PUT',
			}).then(() => {
				this.isBellRinging = false;
			});
		},
		ringTheBell() {
			this.isBellRinging = true;
		},
	},
});
